import { render, staticRenderFns } from "./PushNotificationEdit.vue?vue&type=template&id=6fd23962"
import script from "./PushNotificationEdit.vue?vue&type=script&lang=js"
export * from "./PushNotificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports